var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1487_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    d: "M8,7.07c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S9.93,7.07,8,7.07z M8,1.07 c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5s2.5-1.12,2.5-2.5S9.38,1.07,8,1.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1502_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1246_",
    d: "M3.53,16.02c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S5.46,16.02,3.53,16.02z  M3.53,10.02c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5s2.5-1.12,2.5-2.5S4.91,10.02,3.53,10.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1503_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1243_",
    d: "M12.46,16c-1.93,0-3.5-1.57-3.5-3.5S10.53,9,12.46,9s3.5,1.57,3.5,3.5S14.39,16,12.46,16z M12.46,10 c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5s2.5-1.12,2.5-2.5S13.84,10,12.46,10z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFields);
export default __webpack_public_path__ + "static/media/CommonFields.64fee2c057b233c12fa0e428e1c7327c.svg";
export { ForwardRef as ReactComponent };